import React from "react";

const cities = ["Chandler", "Maricopa", "Ahwatukee", "Tempe", "Gilbert", "Sun Lakes", "Ocotillo"];

export default function Marquee() {
  const items = [...cities, ...cities, ...cities];
  return (
    <section
      data-testid="service-areas-marquee"
      className="border-y border-slate-200 bg-white py-6"
    >
      <div className="marquee">
        <div className="marquee-track">
          {items.map((c, i) => (
            <span
              key={`${c}-${i}`}
              className="inline-flex items-center gap-6 text-sm font-semibold uppercase tracking-[0.3em] text-slate-500"
            >
              {c}
              <span className="h-1.5 w-1.5 rounded-full bg-brand-blue" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
